import Vue from 'vue'
import VueI18n from 'vue-i18n'
import common from '../utils/common'
Vue.use(VueI18n);

import en from '../common/lang/en';
import zh_CN from '../common/lang/zh_CN';
import zh_HK from '../common/lang/zh_HK';
let a = common.getLocale()
/*---------使用语言包-----------*/
let lang = 'zh_CN'
lang = window.locale || 'zh_CN'
const i18n = new VueI18n({
    locale: common.getLocale() || lang, // 语言标识 
    // locale: 'zh_CN',
    messages: {
        zh_CN, //中文简体
        zh_HK, //中文繁体
        en
    },
    silentTranslationWarn: true,
})

export default i18n;